import React from "react";
import { withTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { sendSlackAlert } from "../services/slack";
import { getCorporationData } from "../services/corporation";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };

    this.isAkanthasAccount = (Cookies.get("userEmail") || "").includes(
      "@akanthas.com",
    );
    this.viewMode = Cookies.get("viewMode") || "client";
    this.user = JSON.parse(localStorage.getItem("user")) || null;
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  async componentDidCatch(error, errorInfo) {
    const { t } = this.props;

    console.error(`${t("errorCaptured")}:`, error, errorInfo);

    try {
      const corporationData = await getCorporationData(this.user).then(
        (responseCorporation) => {
          if (
            responseCorporation.status >= 200 &&
            responseCorporation.status < 400
          ) {
            return responseCorporation.data.corporation;
          }
        },
      );
      const datetime = new Date();
      const messageAlert = `An error occurred\nPage: ${window.location.pathname}${this.user && `\nClient: ${corporationData.corporationName}`}\n${this.state.error.toString()}\nTime: ${datetime}`;
      await sendSlackAlert({
        markdown: messageAlert,
        plainText: "Frontend crash warning",
        channels: process.env.REACT_APP_SLACK_FRONTEND_CRASH,
        corporationId: this.user.corporation,
        errorText: this.state.error.toString().split(":")[1]?.trim(),
        page: window.location.pathname,
        datetime: datetime,
      });
    } catch (slackError) {
      console.error("❌ Failed to send Slack alert:", slackError);
    }
  }

  render() {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <div
          className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-6 py-5 text-center"
          style={{ marginTop: -20 }}
        >
          <i className="fas fa-bug text-6xl text-gray-300 mb-4"></i>
          <h1 className="text-4xl font-extrabold text-gray-600 mb-4">
            {t("errorOccurred")}
          </h1>
          <p className="text-lg text-gray-700 mb-6">{t("refreshMessage")}</p>
          {this.isAkanthasAccount && this.viewMode === "admin" && (
            <pre className="max-w-xl w-full bg-red-100 text-red-800 rounded-md p-4 overflow-x-auto text-center">
              {this.state.error && this.state.error.toString()}
            </pre>
          )}
          <button
            onClick={() => window.location.reload()}
            className="mt-8 px-6 py-3 bg-[#00a7a6] text-white rounded-md hover:bg-red-700 transition"
          >
            {t("reloadButton")}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
